const accessProfile = "ACCESS_PROFILE";
const visibleProfile = "ACCESS_DATA_SECURITY|PROFILE";
const updateProfile = "UPDATE_PROFILE";

export const PERMISSIONS_CONFIG = {
    'employee_info': {
        'ACCESS': `${accessProfile}|EMPLOYEE_INFO`,
        'VISIBLE': `${visibleProfile}|EMPLOYEE_INFO`,
        'UPDATE': `${updateProfile}|EMPLOYEE_INFO`
    },
    'employment': {
        'ACCESS': `${accessProfile}|EMPLOYMENT_INFO`,
        'VISIBLE': `${visibleProfile}|EMPLOYMENT_INFO`,
        'UPDATE': `${updateProfile}|EMPLOYMENT_INFO`
    },
    'salary': {
        'ACCESS': `${accessProfile}|SALARY_INFO`,
        'VISIBLE': `${visibleProfile}|SALARY_INFO`,
        'UPDATE': `${updateProfile}|SALARY_INFO`
    }
};